module.exports = __webpack_public_path__ + "static/media/spinner.bd90edf1.gif";